import { ChangeDetectorRef, Component, ElementRef, OnInit, PLATFORM_ID, signal, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MovementsService } from '../../services/movements.service';
import { LoaderComponent } from '../../utils/loader/loader.component';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { isPlatformBrowser } from "@angular/common";
import { ContactInfo, ContactInfoService } from '../../services/contact-info.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-qrviewer',
    imports: [LoaderComponent, CurrencyPipe, CommonModule],
    templateUrl: './qrviewer.component.html',
    styleUrl: './qrviewer.component.scss'
})
export class QRViewerComponent implements OnInit {
  @ViewChild('qrCanvas') qrCanvas!: ElementRef<HTMLDivElement>;

  data: any ={  
    consumption_id :1879290,
    consumption_identifier:'kahjklnajklsnakshju7897abaj8',
    expiration_date:new Date(),
    vehicle:'17',
    amount_requested:200,
    quantity_requested:18902,
    is_volume:false,
    client_number:15,
    product_name:'Supreme +',
    product_id:2,
    message: 'El código ha expirado o no es válido'
  };
  isLoader: boolean = true;
  dataSecure: string = '';
  token = '';
  isSuccess: boolean = false;
  timer = 30;
  qrReady = false;
  isBrowser = signal(false);
  private countdownId: any;
  private qrCode: any;
  contact!: ContactInfo;

  constructor(
    private route: ActivatedRoute,
    private srv: MovementsService,
    private cdr: ChangeDetectorRef,
    private contactSvc: ContactInfoService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser.set(isPlatformBrowser(platformId))
  }
  
  ngOnInit() {
    this.contactSvc.get().subscribe(c => this.contact = c);
    this.isLoader = false;
    //test
    this.dataSecure = this.data.consumption_identifier;
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token') || '';
      if (this.token && !environment.isTest) {
        this.loadSecureIdentifier(this.token);
      }
    });

    if (this.isBrowser() && this.dataSecure) {
      setTimeout(() => this.renderQr(this.dataSecure), 0);
    }
  }

  async renderQr(value: string) {
    this.qrReady = false;
    const QRCodeStyling = (await import('qr-code-styling')).default;
    if (this.qrCode) {
      this.qrCode.update({ data: value });
    } else {
      this.qrCode = new QRCodeStyling({
        width: 180,
        height: 180,
        data: value,
        dotsOptions: { type: 'square', color: '#000000' },
        qrOptions: { errorCorrectionLevel: 'Q' }
      });
      if (this.qrCanvas?.nativeElement) {
        this.qrCode.append(this.qrCanvas.nativeElement);
      }
    }
    this.qrReady = true;
    this.cdr.detectChanges();
  }

  padString(input: string, length: number, padChar: string): string {
    return input.padStart(length, padChar);
  }

  loadSecureIdentifier(identifier: string) {
    this.srv.GetDetailEncryptedConsumption(identifier).subscribe({
      next: (respSecure: any) => {
        this.data = respSecure; 
        this.isSuccess = this.data.isSuccess;
        if (this.isSuccess) {
          this.dataSecure = this.data.consumption_identifier;
          this.startTimerResend();
        } else {
          this.data.message = this.data.message + ", comuníquese con atención a clientes ";
        }
        this.isLoader = false;
      },
      error: (err: any) => {
        this.data.isSuccess = false;
        this.isSuccess = this.data.isSuccess;
        this.data.message = err.message + ", comuníquese con atención a clientes ";
      }
    });
  }

  startTimerResend() {
    this.timer = 30;
    if (this.isBrowser()) {
      this.countdownId = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          clearInterval(this.countdownId);
          this.dataSecure = "";
          this.loadSecureIdentifier(this.token);
        }
      }, 1000);
    }
  }
}
